import React, { useState, useEffect } from "react";
import { useStores } from "@/store";

/**预登录 */
export default (props) => {
  const { memberStore } = useStores();
  const [hasLogin, setLogin] = useState(false);
  useEffect(() => {
    memberStore
      .show()
      .then(() => {
        setLogin(true);
        document.body.classList.add("loaded");
      })
      .catch((error) => {
        setLogin(true);
        document.body.classList.add("loaded");
      });
  }, []);
  return hasLogin ? <>{props.children}</> : <div></div>;
};
